// The guides hub (/guides and /guides/<slug>, src/pages/guides) is STAGING ONLY until the owner approves it for
// production: where it's off, every /guides* URL is a real 404, the sitemap leaves the guides out and no footer or
// feature page links to them.
//
// Same switch as the new home page (src/lib/homeFlag.ts): the deployment's pinned PHOTOHAWK_ENV, never a visitor's
// ?phEnv / localStorage override. Launch: set GUIDES_IN_PROD to true in a reviewed PR, once the TODO(owner) items in
// the guides are filled in (src/content/guides/guides.test.tsx checks there are none left when it's true).

import { deploymentEnv, type DeploymentEnv } from "./homeFlag";

// Live in production on the owner's instruction, 21 Oct 2026 ("Make them live").
export const GUIDES_IN_PROD = true;

/** Where the hub lives. */
export const GUIDES_PATH = "/guides";

/** Whether the guides are on for a deployment env. */
export const guidesEnabledFor = (env: DeploymentEnv, inProd: boolean = GUIDES_IN_PROD): boolean => env !== "prod" || inProd;

/** Whether this deployment shows the guides (staging: yes; prod: no until the owner approves them). */
export const isGuidesEnabled = (host?: string): boolean => guidesEnabledFor(deploymentEnv(host));
